/**企业场地配置 js */
import config from "@/config";
import http from "@/utils/request";

export default {
	siteConfigList: {
		url: `${config.MAIN_URL}/company/site/siteConfigList`,
		name: "企业场地配置查询",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	setDefaultPosition: {
		url: `${config.MAIN_URL}/company/site/setDefaultPosition`,
		name: "默认位置设置",
		put: async function (params) {
			return await http.put(this.url + params);
		},
	},
	putswitch: {
		url: `${config.MAIN_URL}/api/v1/monitor/switch`,
		name: "用户设置监视开关状态",
		put: async function (params) {
			return await http.put(this.url + params);
		},
	},
	deviceswitch: {
		url: `${config.MAIN_URL}/api/v1/device/switch`,
		name: "用户设置RID开关状态",
		put: async function (params) {
			return await http.put(this.url + params);
		},
	},
	monitorswitch: {
		url: `${config.MAIN_URL}/api/v1/monitor/switch`,
		name: "获取用户设置的监视开关状态",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	getdevswitch: {
		url: `${config.MAIN_URL}/api/v1/device/switch`,
		name: "用户获取RID开关状态",
		get: async function (params) {
			return await http.get(this.url , params);
		},
	},
	

};
